module.exports = __webpack_public_path__ + "static/media/palitlig.ada19d25.mp3";